const countDownDate = new Date("Sep 1, 2020").getTime();
const days = Math.floor( (countDownDate - new Date().getTime()) / (1000 * 60 * 60 * 24));
export default days;
